export default "https://assets.pclncdn.com/web/next-landing/7389f49ac8/_next/static/images/miami-225034551190f91d96c2c5a65a75fc65.webp";